import { render, staticRenderFns } from "./CoreBarProfile.vue?vue&type=template&id=66cfb1ba&scoped=true&"
import script from "./CoreBarProfile.vue?vue&type=script&lang=js&"
export * from "./CoreBarProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cfb1ba",
  null
  
)

export default component.exports